<script lang="ts">
    export let lineColor = "#ff00ff";
</script>

<rect x="0" y="0" width="1600" height="375" fill={lineColor} />
